import { NODE_TYPE_PREFIX } from '../basis/auditConfig/components/flow/constants';

export const CUSTOMCUL_FLOW_CONF = {
  configName: '自定义列配置-审批列表',
  configKey: 'CustomColByFlow',
  defaultFrozenNum: 2,
};
// 流程状态
export const FLOW_STATUS = {
  UNDERWAY: 10, // 审批中
  APPROVED: 11, // 已同意
  REJECTED: 12, // 拒绝
  REVOKE: 9, // 撤销
} as const;
// 流程指令
export const CMD = {
  REJECTED: 0, // 0 不通过
  APPROVED: 1, // 1 通过
  UNDERWAY: 2, // 2 处理中
} as const;
export const NODE = {
  START: 2, // 2 提交
  APPROVE: 3, // 3 审批
  COPY: 4, // 4 抄送
  AUDIT_OR: 5, // 5-审批中-或签
  AUDIT_AND: 6, // 6-审批中-会签
  CANCEL: 9, // 9-撤消

  // 前端自用 可更改值
  END: 10, // 10-结束
} as const;

export const ADDTRANSFORM_NODETYPE_MAP = {
  [NODE_TYPE_PREFIX.START]: NODE.START,
  [NODE_TYPE_PREFIX.END]: NODE.END,
  [NODE_TYPE_PREFIX.AUDIT_OR]: NODE.AUDIT_OR,
  [NODE_TYPE_PREFIX.AUDIT_AND]: NODE.AUDIT_AND,
  [NODE_TYPE_PREFIX.CC]: NODE.COPY,
};
export const BUSINESS_KEY = {
  MPA: 'MPA', // 物料采购
  DOA: 'DOA', // 版单
  PWPA: 'PWPA', // 工序节点
  DONA: 'DONA', // 样衣节点
  FAOA: 'FAOA', // 费用预支
  FROA: 'FROA', // 费用报销
} as const;
export type FLOW_BUSINESS_KEY = ExtractObjVal<typeof BUSINESS_KEY>;
export interface FlowNode {
  nodeCode: string; // 节点编码
  auditTime: string;
  underway: boolean;
  flowCmd: number; // 操作类型
  flowNodeName: string; // 节点名称
  auditor: number; // 审批人
  assignee: number; // 转交人
  multiInstanceApprovalType: number; // 会签类型
  roleIds: number[]; // 审批角色

  type: ExtractObjVal<typeof NODE>; // 节点类型
  result: ExtractObjVal<typeof CMD>; // 审批结果
  title: string; // 审批标题
  businessTime: number; // 处理时间
  users: Recordable[]; // 处理人
  remark: string; // 审批意见
  attachments: Recordable[]; // 审批附件
}
export const FLOW_STATUS_LIST = [
  { val: FLOW_STATUS.UNDERWAY, text: '审批中', color: 'blue' },
  { val: FLOW_STATUS.APPROVED, text: '已同意', color: 'green' },
  { val: FLOW_STATUS.REJECTED, text: '拒绝', color: 'red' },
  { val: FLOW_STATUS.REVOKE, text: '已撤销', color: 'gray' },
];
export const FLOW_TAB = {
  TO_ME: 2, // 待我审批
  MY_APPROVAL: 3, // 我已审批
  MY_APPLY: 4, // 我的申请
  CC_ME: 5, // 抄送我的
  ALL: 6, // 全部
} as const;
export const flowCommonTab = [
  {
    text: '待我审批',
    val: FLOW_TAB.TO_ME,
    orderCountField: 'awaitingApprovalCount',
    color: 'orangeRed',
  },
  {
    text: '我已审批',
    val: FLOW_TAB.MY_APPROVAL,
    orderCountField: '',
    color: 'orangeRed',
  },
  {
    text: '我的申请',
    val: FLOW_TAB.MY_APPLY,
    orderCountField: '',
    color: 'orangeRed',
  },
  {
    text: '抄送我的',
    val: FLOW_TAB.CC_ME,
    orderCountField: '',
    color: 'orangeRed',
  },
  {
    text: '全部',
    val: FLOW_TAB.ALL,
  },
];
export type FlowCommonTab = ExtractObjVal<typeof FLOW_TAB>;

export const flowColumns = [
  {
    title: '审批状态',
    field: 'businessState',
    fixed: 'left',
    width: 60,
    type: 'slot',
    slotName: 'businessState',
    // render: 'Tag',
    // params: FLOW_STATUS_LIST,
  },
  {
    title: '审批类型',
    field: 'flowName',
    headerAlign: 'left',
    align: 'left',
    width: 60,
    class: 'color-theme',
    type: 'route',
  },
  {
    title: '创建人',
    field: 'handlerName',
    headerAlign: 'left',
    align: 'left',
    width: 60,
  },
  {
    title: '描述',
    field: 'description',
    headerAlign: 'left',
    align: 'left',
    width: 400,
    showTooltip: true,
  },
  {
    title: '当前审批人',
    field: 'taskUsers',
    headerAlign: 'left',
    align: 'left',
    width: 60,
    type: 'slot',
    slotName: 'taskUsers',
  },
  {
    title: '当前节点截止日期',
    field: 'deadline',
    align: 'left',
    width: 120,
    default: '-',
    type: 'slot',
    slotName: 'deadline',
    sortable: true,
  },
  {
    title: '创建时间',
    field: 'createTime',
    width: 120,
    type: 'day',
    default: '-',
    format: 'YYYY-MM-DD HH:mm',
    headerAlign: 'left',
    align: 'left',
    sortable: true,
  },
  {
    title: '审批完成时间',
    field: 'finishTime',
    width: 120,
    type: 'day',
    default: '-',
    format: 'YYYY-MM-DD HH:mm',
    headerAlign: 'left',
    align: 'left',
    sortable: true,
  },
  {
    title: '操作',
    field: 'operate',
    type: 'operate',
    headerAlign: 'left',
    align: 'left',
    width: 80,
  },
];
